import React from 'react';
import { ApplicationFormStatus, ApplicationStatus } from '../../../shared/types/enums';
import './pill.scss';
export var Pill = function (_a) {
    var _b;
    var status = _a.status, formStatus = _a.formStatus, stageStatus = _a.stageStatus;
    var usedStatus = status
        ? ApplicationStatus[status]
        : formStatus
            ? ApplicationFormStatus[formStatus]
            : ApplicationStatus[stageStatus];
    usedStatus =
        usedStatus == 'undefined'
            ? ApplicationStatus[ApplicationStatus.NoStatus]
            : usedStatus !== null && usedStatus !== void 0 ? usedStatus : ApplicationStatus[ApplicationStatus.NoStatus];
    var formatName = function (apStat) {
        switch (apStat) {
            case ApplicationStatus.AutoDeclineCancelled: //AutoDecisionDeclinedCancellation
            case ApplicationStatus.AutoDeclinedWaitingForMoreInfo:
            case ApplicationStatus.AutoDeclinedWithMoreInfoSubmited:
            case ApplicationStatus.AutoDeclined:
                return 'Auto Declined';
            case ApplicationStatus.ReferredWaitingForMoreInfo:
            case ApplicationStatus.ReferredWithMoreInfoSubmited:
            case ApplicationStatus.CallValidateCallCreditRefer:
            case ApplicationStatus.Pending:
                return 'Referred';
            case ApplicationStatus.DeclinedWaitingForMoreInfo:
            case ApplicationStatus.DeclinedWithMoreInfoSubmited:
            case ApplicationStatus.CallValidateCallCreditFail:
                return 'Declined';
            case ApplicationStatus.AutoRefer:
                return 'Auto Refer';
            case ApplicationStatus.NoStatus:
                return 'Outstanding';
            case ApplicationStatus.Closed:
                return 'Cancelled';
            default:
                return "".concat(usedStatus);
        }
    };
    var displayName = formatName((_b = status !== null && status !== void 0 ? status : formStatus) !== null && _b !== void 0 ? _b : stageStatus);
    return React.createElement("p", { className: "c-pill ".concat(usedStatus) }, displayName);
};
